export const METHOD_TYPE = {
    get: "get",
    post: "post",
    put: "put",
    delete: "delete",
};

export const API_ENDPOINTS = {
    verifyCredentialsAndSendOtp: '/user/verifyCredentialsAndSendOtp',
    verifyLoginOtp: '/user/verifyLoginOtp',
    logoutUser: '/user/logout',
    // Every sign-in with its device, and every device stored for the screening profiles (14 Oct 2026).
    loginHistory: '/user/login-history',
    deviceRecords: '/entity_client_devices/list',
    updateFirstTimeLogin: '/user/updateFirstTimeLogin',
    register: '/user/register',
    sendSignupOtp: '/user/sendSignupOtp',
    getCountryList: '/fxrates/getCountryList',
    fetchAllTax: '/tax/fetchAllTax',
    taxOverview: '/tax/overview',
    saveCompanyTaxSettings: '/tax/company-settings',
    addNewTax: '/tax/create',
    fetchTaxDetails: '/tax/fetchTaxDetails',
    updateTaxData: '/tax/updateTax',
    deleteTax: '/tax/delete',
    getCompanyCountryTaxMapping: '/tax/getCompanyCountryTaxMapping',
    saveCompanyCountryTaxMapping: '/tax/saveCompanyCountryTaxMapping',
    austracEnrolment: '/austrac-enrolment',
    saveAustracEnrolment: '/austrac-enrolment/save',
    submitAustracEnrolment: '/austrac-enrolment/submit',
    uploadAustracEnrolmentDocument: '/austrac-enrolment/upload-document',
    archiveCompanyPersonRole: '/austrac-enrolment/archive-person-role',
    fetchActivePlan: '/package/getActivePackage',
    sendCustomPackageInquiryEmail: '/package/sendCustomPackageInquiryEmail',
    initiateOrder: '/order/initiateOrder',
    placeOrder: '/order/placeOrder',
    fetchActiveRoles: '/role/fetchEntityActiveRoles',
    fetchAllRoles: '/role/fetchAllRoles',
    fetchRoleDetails: '/role/fetchById',
    deleteRole: '/role/delete',
    addNewRole: '/role/create',
    getCurrencyList: '/fxrates/getCurrencyList',
    getFxRateBasedByBaseCurrency: '/fxrates/fetchFxRateByBaseCurrency',
    getAllFxRates: '/fxrates/fetchAllFxRates',
    exportFxRatesPdf: '/fxrates/exportPdf',
    exportFxRatePdf: '/fxrates/exportRatePdf',
    createFxRate: '/fxrates/create',
    deleteFxRate: '/fxrates/delete',
    fetchFxRateDetailById: '/fxrates/fetchFxRateDetailById',
    updateFxRate: '/fxrates/update',
    fetchFxRateHistoryList: '/fxrates/fetchFxRateHistoryList',
    fetchUserList: '/user/fetchUserList',
    generateGoogleAuthenticatorQR: '/user/generateGoogleAuthenticatorQR',
    manageGoogleAuthenticator: '/user/manageGoogleAuthenticator',
    loginWithGoogleAuthenticator: '/user/loginWithGoogleAuthenticator',
    getEntityActivePackage: '/package/getEntityActivePackage',
    deactivateUser: '/user/deactivateUser',
    reactivateUser: '/user/reactivateUser',
    deleteUser: '/user/deleteUser',
    createRole: '/role/create',
    fetchOomeroEntity: '/entity/getOomeroEntity',
    resendPostpaidInvite: '/user/resendPostpaidInvite',
    resendInviteEmail: '/user/resendInviteEmail',
    addNewUser: '/user/addUser',
    fetchClientEntity: '/entity/getClientEntity',
    fetchUserDetails: '/user/fetchUserDetails',
    updateUserDetails: '/user/updateUser',
    fetchRoleById: '/role/fetchById',
    updateRole: '/role/update',
    getAllEntities: '/entity/getAllEntities',
    changeEntityStatus: '/entity/changeEntityStatus',
    setUserPassword: '/user/setInviteUserPassword',
    changePassword: '/user/changePassword',
    fetchAllEntityBillingList: '/invoice/fetchAllEntityBillingList',
    billingSidebarData: '/invoice/billingSidebarData',
    downloadEntityInvoice: '/invoice/downloadEntityInvoice',
    sendPayBalanceOtp: '/invoice/sendPayBalanceOtp',
    verifyPayBalanceOtp: '/invoice/verifyPayBalanceOtp',
    fetchInvoiceDetail: '/invoice/fetchInvoiceDetail',
    entityPreviousInvoiceList: '/invoice/entityInvoiceList',
    requestPrintAudit: '/print/request',
    printAuditLogs: '/print/audit-logs',
    auditorAssignment: '/auditor/assignment',
    auditorAssignments: '/auditor/assignments',
    auditorCompanyUsers: '/auditor/company-users',
    auditorResendInvitation: '/auditor/resend-invitation',
    auditorCloseAudit: '/auditor/close-audit',
    auditorActivationLogs: '/auditor/activation-logs',
    auditorCheckedItems: '/auditor/checked-items',
    auditorScopeOptions: '/auditor/scope-options',
    auditorScope: '/auditor/scope',
    auditorToggleCheck: '/auditor/toggle-check',
    auditorPrintRequest: '/auditor/print-request',
    auditorAlerts: '/auditor/alerts',
    deleteAmlCheck: '/aml-check/delete',
    convertAmlCheckToOnboarding: '/aml-check/convert-onboarding',
    // The AML Actions tab of an AML check (5 Oct 2026): a screening action of its own for every check.
    amlCheckScreeningDetails: '/aml_check_screening/details',
    amlCheckScreeningUpdate: '/aml_check_screening/update',
    amlCheckScreeningUploadDocument: '/aml_check_screening/uploadDocument',
    amlCheckScreeningRequestDocument: '/aml_check_screening/requestDocument',
    amlCheckScreeningDeleteDocument: '/aml_check_screening/deleteDocument',
    amlCheckScreeningForward: '/aml_check_screening/forward',
    amlCheckScreeningSendBack: '/aml_check_screening/sendBack',
    amlCheckScreeningDecide: '/aml_check_screening/decide',
    amlCheckMonitoringStatus: '/aml_check_monitoring/status',
    amlCheckMonitoringCheck: '/aml_check_monitoring/check',
    amlCheckMonitoringReview: '/aml_check_monitoring/review',
    amlCheckMonitoringResync: '/aml_check_monitoring/resync',
    adverseMediaCompare: '/adverse_media_compare/compare',
    billingLedger: '/billing/ledger',
    getEntityDetails: '/entity/getEntityDetails',
    getPostpaidEntityDetails: '/user/getPostpaidEntityDetails',
    sendForgotPasswordCode: "user/sendForgotPasswordCode",
    resetPasswordOtpVerify: "/user/verifyForgotPasswordCode",
    changeForgetPassword: "user/setNewPassword",
    getAllPackage: "package/getAllPackage",
    deactivatePackage: "package/deactivatePackage",
    updatePackage: "package/update",
    createNewPackage: "package/create",
    getInvoiceData: "/invoice/getMyInvoices",
    saveIndividualPersonalDetails: "/individual_onboarding/saveIndividualPersonalDetails",
    saveIndividualAddress: "/individual_onboarding/saveIndividualAddress",
    uploadEntityClientDocument: "/individual_onboarding/uploadEntityClientDocument",
    saveEntityClientKycDetail: "/individual_onboarding/saveEntityClientKycDetail",
    getEntityClientCompany: "/individual_onboarding/getEntityClientCompany",
    getEntityClientBank: "/individual_onboarding/getEntityClientBank",
    postEntityClientCompany: "/individual_onboarding/createEntityClientCompany",
    generateFaceKycLink: "/individual_onboarding/generateFaceKycLink",
    processFaceKyc: "/individual_onboarding/processFaceKyc",
    getOnboardingApplications: "/individual_onboarding/getOnboardingApplications",
    resendOnboardingInviteLink: "/individual_onboarding/resendOnboardingInviteLink",
    resendOomeroIdEmail: "/individual_onboarding/resendOomeroIdEmail",
    getWebformProgress: "/individual_onboarding/getWebformProgress",
    recoverOomeroId: "/individual_onboarding/recoverOomeroId",
    postEntityClientBank: "/individual_onboarding/createEntityClientBanks",
    fetchEntityClientPersonalDetail: "individual_onboarding/fetchEntityClientPersonalDetail",
    profileDirectory: "/profile-directory",
    fetchEntityClientAddress: "/individual_onboarding/fetchEntityClientAddress",
    updateIndividualPersonalDetails: "/individual_onboarding/updateIndividualPersonalDetails",
    oomeroIdCountryChanges: "/oomero-id-country-changes",
    generateOnboardingInviteLink: "/individual_onboarding/generateOnboardingInviteLink",
    fetchEntityData: '/individual_onboarding/fetchEntityData',
    deductKYCLivelynessCharge: '/individual_onboarding/chargeKYCLivelyness',
    getIndividualScreeninglist: '/individual_screening/getIndividualScreeninglist',
    listPendingKYCIndividualScreening: '/individual_screening/getInactiveOomeroClients',
    updateIndividualPersonalDetailsWithReason: '/individual_screening/updateIndividualPersonalDetailsWithReason',
    addScreeningComments: '/individual_screening/addScreeningComments',
    getEntityClientBankDetails: '/individual_onboarding/getEntityClientBankDetails',
    getEntityClientCompanyDetails: '/individual_onboarding/getEntityClientCompanyDetails',
    listKycDocuments: '/individual_screening/listKycDocuments',
    requestDocument: '/individual_screening/requestDocument',
    uploadDocument: '/individual_screening/uploadDocument',
    updateScreeningInfo: '/individual_screening/updateScreeningInfo',
    getScreeningComments: '/individual_screening/getScreeningComments',
    getFieldHistory: '/individual_screening/getFieldHistory',
    getCustomerInteractionLog: '/individual_screening/getCustomerInteractionLog',
    getGlobalSearchById: '/individual_screening/getGlobalSearchById',
    getAllGlobalSearchById: '/individual_screening/getAllGlobalSearchById',
    getIndividualScreeningClientHistory: "/individual_screening/getIndividualScreeningClientHistory",
    saveRelevantResult: "/individual_screening/saveRelevantResult",
    updateAmlResultReview: "/individual_screening/updateAmlResultReview",
    removeRelevantResult: "/individual_screening/removeRelevantResult",
    getSearchCertificate: "/individual_screening/getSearchCertificate",
    manageScreeningAction: "/individual_screening/manageScreeningAction",
    getInactiveOomeroApplications: "/individual_screening/getInactiveOomeroApplications",
    resendFaceKycLink: "/individual_onboarding/resendFaceKycLink",
    getAdverseMedia: "/individual_screening/getAdverseMedia",
    manageContinuousMonitoring: "/individual_screening/manageContinuousMonitoring",
    saveExcludedAdverseMedia: "/individual_screening/saveExcludedAdverseMedia",
    checkUKVatNo: "/individual_onboarding/checkUKVatNo",
    manageEntityClientStatus: "/individual_screening/manageEntityClientStatus",
    reviewFacialDuplicate: "/individual_screening/reviewFacialDuplicate",
    overrideIdvResult: "/individual_screening/overrideIdvResult",
    reviewKycComparison: "/individual_screening/reviewKycComparison",
    refreshToken: `/user/refreshToken`,
    saveAmlInfoComment: "/individual_screening/saveAmlInfoComment",
    saveAdverseMediaComment: "/individual_screening/saveAdverseMediaComment",
    downloadClientDocZipFiles: "/individual_screening/downloadClientDocZipFiles",
    resendToCheckerMaker: "/individual_screening/resendToCheckerMaker",
    packageUpdate: "/package/update",
    getPackageDetails: "/package/getPackageDetails",
    fetchAmlComments: "/individual_screening/fetchAmlComments",
    getAmlReviewSignoffs: "/individual_screening/getAmlReviewSignoffs",
    setAmlReviewSignoff: "/individual_screening/setAmlReviewSignoff",
    fetchUploadedDocuments: "/individual_screening/fetchUploadedDocuments",
    uploadMediaImage: "/individual_screening/uploadMediaImage",
    autoSearchAddress: "/individual_onboarding/autoSearchAddress",
    resendToScreening: "/individual_screening/resendToScreening",
    checkEUVatNo: "/individual_onboarding/checkEUVatNo",
    getIndividualScreeningPercentage: "/dashboard/getIndividualScreeningPercentage",
    getKeyStatsForGraph: "/dashboard/getKeyStatsForGraph",
    getStatsByGraph: "/dashboard/getStatsByGraph",
    sendToCheckerMlro: "/individual_screening/sendToCheckerMlro",
    checkPanUrl: "/individual_onboarding/checkPan",
    checkAadhaarUrl: "/individual_onboarding/checkAadhaar",
    createDigiLockerUrl: "/signzy/createUrlDigiLocker",
    getDigiLockerDetails: "/signzy/digiLocker/getDetails",
    getDigiLockerFiles: "/signzy/digiLocker/getFiles",
    pullDigiLockerDocuments: "/signzy/digiLocker/pullDocuments",
    digilockerVault: "/digilocker-vault",
    createDigiLockerSession: "/digilocker-vault/sessions",
    createDigiLockerShare: "/digilocker-vault/shares",
    digilockerPublicShare: "/digilocker-share",
    getOnboardedClientReport: "/individual_onboarding/getOnboardedClientReportData",
    downloadOnboardedClientReport: "/individual_onboarding/downloadOnboardedClientReport",
    downloadOnboardedClientReportPackage: "/individual_onboarding/downloadOnboardedClientReportPackage",
    getEntityCertificate: "/individual_screening/getEntityCertificate",
    searchCorporateCompany: "/corporate_onboarding/searchCorporatePersonalDetails",
    getPreviousSearchRecords: "/aml_check/getPreviousSearchRecords",
    initialSearch: "/aml_check/initialSearch",
    startAmlFullOnboarding: "/aml_check/startFullOnboarding",
    saveCompanyAddress: "/corporate_onboarding/saveCompanyAddress",
    updateCompanyAddress: "/corporate_onboarding/updateCompanyAddress",
    saveCompanyDetailsAndAddress: "/corporate_onboarding/saveCompanyDetailsAndAddress",
    saveCorporateInternationalProfile: "/corporate_onboarding/saveInternationalProfile",
    saveCorporateRegulatoryDocuments: "/corporate_onboarding/saveRegulatoryDocuments",
    getCorporateRegulatoryDocuments: "/corporate_onboarding/getRegulatoryDocuments",
    saveCorporateCompliance: "/corporate_onboarding/saveCompliance",
    getCorporateCompliance: "/corporate_onboarding/getCompliance",
    saveCorporateMlro: "/corporate_onboarding/saveMlroDetails",
    getCorporateMlro: "/corporate_onboarding/getMlroDetails",
    deleteCorporateMlro: "/corporate_onboarding/deleteMlroDetails",
    createCorporateWebformLink: "/corporate_onboarding/createCorporateWebformLink",
    initializeCorporateWebform: "/corporate_onboarding/initializeCorporateWebform",
    getCorporateWebformSummary: "/corporate_onboarding/getCorporateWebformSummary",
    completeCorporateWebform: "/corporate_onboarding/completeCorporateWebform",
    getCorporateOnboardingApplications: "/corporate_onboarding/getOnboardingApplications",
    resendCorporateOnboardingInviteLink: "/corporate_onboarding/resendOnboardingInviteLink",
    corporateOnboardingApplication: "/corporate_onboarding/onboarding-application",
    updateCompanyDetailsAndAddress: "/corporate_onboarding/updateCompanyDetailsAndAddress",
    getCompanyAddress: "/corporate_onboarding/getCompanyAddress",
    getCompanyDetails: "/corporate_onboarding/getCompanyDetailsForAll",
    saveCorporateDeatils: "/corporate_onboarding/saveCorporatePersonalDetails",
    getCompanyHouseCorporateDetails: "/corporate_onboarding/redFlagCompanyHouseCorporateDetails",
    createBankDetails: "corporate_onboarding/createBankDetails",
    updateBankDetails: "/corporate_onboarding/updateBankDetails",
    uploadDocuments: "corporate_onboarding/uploadDocuments",
    updateUploadDocuments: "/corporate_onboarding/updateUploadDocuments",
    fetchCorporateBankDetails: "/corporate_onboarding/fetchCorporateBankDetails",
    fetchCorporateUploadedDocument: '/corporate_onboarding/fetchCorporateUploadedDocument',
    fetchAmlCheckSearchDetails: "/aml_check/fetchAmlCheckSearchDetails",
    amlCheckManageContinuousMonitoring: "/aml_check/manageContinuousMonitoring",
    amlCheckContinuousMonitoringPrice: "/aml_check/continuousMonitoringPrice",
    getAmlCheckSearchCertificate: "/aml_check/getAmlCheckSearchCertificate",
    getAmlCheckEntityCertificate: "/aml_check/getAmlCheckEntityCertificate",
    amlCheckReport: "/aml_check/report",
    getCompanyOfficers: "/corporate_onboarding/getCompanyOfficers",
    deleteCompanyOfficers: "/corporate_onboarding/deleteCompanyOfficers",
    getEntityClientDetailsByOomeroId: "/corporate_onboarding/getEntityClientDetailsByOomeroId",
    verifyEntityClientDetailsOtp: "/corporate_onboarding/verifyEntityClientDetailsOtp",
    saveCorporateClientOfficer: "/corporate_onboarding/saveCorporateClientOfficer",
    triggerKycOnboardEmail: "/corporate_onboarding/triggerKycOnboardEmail",
    getCorporateIndividualShareholder: "/corporate_onboarding/getCorporateIndividualShareholder",
    saveCorporateIndividualShareholder: "/corporate_onboarding/saveCorporateIndividualShareholder",
    fetchAllCorporateIndividualShareholders: "/corporate_onboarding/fetchAllCorporateIndividualShareholders",
    importCorporateMembers: "/corporate_member_import/import",
    saveCompanyShareholderRepresentativeDetails: "/corporate_onboarding/saveCompanyShareholderRepresentativeDetails",
    getCompanyShareholderRepresentativeDetails: "/corporate_onboarding/getCompanyShareholderRepresentativeDetails",
    updateCompanyShareholderRepresentativeDetails: "/corporate_onboarding/updateCompanyShareholderRepresentativeDetails",
    getCorporateScreeninglist: "/corporate_screening/getCorporateScreeninglist",
    manageCorporateContinuousMonitoring: "/corporate_screening/manageContinuousMonitoring",
    getCorporateClientDetails: "/corporate_onboarding/getCorporateClientDetails",
    generateCorporateClientOomeroId: "/corporate_onboarding/generateCorporateClientOomeroId",
    fetchCorporateClientPersonalDetail: "/corporate_screening/fetchCorporateClientPersonalDetail",
    getCorporateLinkedIndividuals: "/corporate_screening/getCorporateLinkedIndividuals",
    manageCorporateClientStatus: "/corporate_screening/manageCorporateClientStatus",
    downloadCorporateClientDocZipFiles: "/corporate_screening/downloadCorporateClientDocZipFiles",
    downloadCorporateReportPackage: "/corporate_onboarding/downloadCorporateReportPackage",
    addCorporateScreeningComments: "/corporate_screening/addScreeningComments",
    updateCorporateDetailsWithReason: "/corporate_screening/updateCorporateDetailsWithReason",
    saveCorporateRelevantResult: "/corporate_screening/saveRelevantResult",
    removeCorporateRelevantResult: "/corporate_screening/removeRelevantResult",
    getCorporateGlobalSearchById: "/corporate_screening/getGlobalSearchById",
    fetchRequestedUploadedDocuments: "/corporate_screening/fetchRequestedUploadedDocuments",
    corporateRequestDocument: '/corporate_screening/requestDocument',
    corporateUploadDocument: '/corporate_screening/uploadDocument',
    corporateUpdateScreeningInfo: '/corporate_screening/updateScreeningInfo',
    corporateResendToCheckerMaker: "/corporate_screening/resendToCheckerMaker",
    corporateSendToCheckerMlro: "/corporate_screening/sendToCheckerMlro",
    corporateManageScreeningAction: "/corporate_screening/manageScreeningAction",
    fetchCorporateBankDetailsById: '/corporate_onboarding/fetchCorporateBankDetailsById',
    getCorporateFieldHistory: '/corporate_screening/getCorporateFieldHistory',
    getCorporateScreeningComments: '/corporate_screening/getCorporateScreeningComments',
    getCorporateScreeningClientHistory: "/corporate_screening/getCorporateScreeningClientHistory",
    fetchCorporateRequestedDocuments: '/corporate_screening/fetchCorporateRequestedDocuments',
    getCorporateTransactionsList: '/corporate_transaction/getTransactionsList',
    createCorporateTransaction: '/corporate_transaction/create',
    getCorporateTransactionDocuments: '/corporate_transaction/getDocuments',
    fetchPendingCorporateScreeningCount: '/corporate_screening/fetchPendingCorporateScreeningCount',
    triggerReKycEmail: '/corporate_screening/triggerReKycEmail',
    getClientIndividualScreeninglist: '/individual_screening/getClientIndividualScreeninglist',
    updateCorporateClientOfficer: '/corporate_onboarding/updateCorporateClientOfficer',
    updateCorporateIndividualShareholder: '/corporate_onboarding/updateCorporateIndividualShareholder',
    getIndividualProfileByOomeroId: '/individual_onboarding/getIndividualProfileByOomeroId',
    individualOnboardUsingOomeroId: '/individual_onboarding/individualOnboardUsingOomeroId',
    getCorporateProfileByOomeroId: '/corporate_onboarding/getCorporateProfileByOomeroId',
    corporateOnboardingUsingOomeroId: '/corporate_onboarding/corporateOnboardingUsingOomeroId',
    getPreviousSearches: '/company_search/getPreviousSearches',
    getCompanySearchDetails: '/company_search/getCompanySearchDetails',
    getCorporateAmlReportData: '/corporate_onboarding/getCorporateAmlReportData',
    getPaymentHistory: '/order/getPaymentHistory',
    corporateResendToScreening: '/corporate_screening/resendToScreening',
    getCompanyReportData: '/company_search/getCompanyReportData',
    getCorporateSearchCertificate: '/corporate_screening/getCorporateSearchCertificate',
    getOnboardingApplications: '/individual_onboarding/getOnboardingApplications',
    getIndividualScreeningPercentageOnboarded: "/dashboard/getIndividualScreeningPercentage?section=onboarded",
    getIndividualScreeningPercentageScreening: "/dashboard/getIndividualScreeningPercentage?section=screening",
    getCorporateBucketStatus: "/dashboard/getCorporateBucketStatus",
    getGeographicProfileCounts: "/dashboard/getGeographicProfileCounts",
    getDashboardCommandCenter: "/dashboard/commandCenter",
    sendPostPaidClientLink: "/user/sendPostPaidClientLink",
    onboardPostpaidEntity: "/user/onboardPostpaidEntity",
    setPostPaidClientPassword: "user/setPostPaidClientPassword",
    duplicateApproveReject: "individual_screening/duplicateApproveReject",
    fetchPostpaidBillingList: "/invoice/fetchPostpaidBillingList",
    fetchPostpaidClientBillingDetails: "/invoice/fetchPostpaidClientBillingDetails",
    getWalletTransactionTable: "/wallet/transactions",
    walletBalance: '/wallet/getWalletBalance',
    walletTransactions: '/wallet/getWalletTransactions',
    walletTopup: '/wallet/prepaidTopUpWallet',
    walletPaymentResponse: '/wallet/paymentResponse',
    walletPaymentFinalize: '/wallet/paymentFinalize',
    walletDebit: '/wallet/debit',
    getAllEmailTemplates: '/email_template/all',
    createCustomEmailTemplate: '/email_template/custom',
    getEntityLogo: '/email_template/entity-logo',
    uploadEntityLogo: '/email_template/entity-logo/upload',
    getGeographicRiskList: '/geographic_risk/list',
    updateGeographicRisk: '/geographic_risk/update',
    createGeographicRisk: '/geographic_risk/create',
    deleteGeographicRisk: '/geographic_risk/delete',
    getFatfSyncStatus: '/geographic_risk/fatf-sync/status',
    syncFatfCountries: '/geographic_risk/fatf-sync',
    getFatfMap: '/geographic_risk/fatf-map',
    getFaqList: '/faq/list',
    createFaq: '/faq/create',
    updateFaq: '/faq/update',
    deleteFaq: '/faq/delete',
    getPublicLoginNewsBlocks: '/login-news/public',
    getLoginNewsBlocks: '/login-news',
    createLoginNewsBlock: '/login-news',
    updateLoginNewsBlock: '/login-news',
    deleteLoginNewsBlock: '/login-news',
    uploadLoginNewsMedia: '/login-news/media/upload',
    // Payment gateways: BreathePay or Stripe, and every payment attempt (docs/PAYMENTS.md in oomero-be).
    paymentSettings: '/payments/settings',
    paymentTransactions: '/payments/transactions',
    stripePaymentConfirm: '/payments/stripe/confirm',
    getCountriesList: '/geographic_risk/countries',
    generatePostpaidInvoice: '/invoice/generatePostpaidInvoice',
    submitCustomPackageInquiry: '/package/submitCustomPackageInquiry',
    getInquiriesCount: '/package/getInquiriesCount',
    getAllInquiries: '/package/getAllInquiries',
    updateInquiryStatus: '/package/updateInquiryStatus',
    getRiskScoringQuestions: '/riskScoring/questions',
    submitRiskScoringResponse: '/riskScoring/response',
    getTotalRisk: '/riskScoring/total-risk',
    uploadRiskEvidence: '/riskScoring/upload-evidence',
    getUserAnswers: '/riskScoring/user-answers',
    emailHistoryZoho: '/email-history/zoho',
    emailLogs: '/email-logs',
    getOomeroCompanyCountryAssignments: '/super-admin/oomero-companies',
    createOomeroCompanyCountryAssignment: '/super-admin/oomero-companies',
    updateOomeroCompanyCountryAssignment: '/super-admin/oomero-company-country-assignments',
    getSelfServiceTaxProfiles: '/tax-profiles',
    createSelfServiceTaxProfile: '/tax-profiles',
    getSelfServiceFxRates: '/fx-rates',
    createSelfServiceFxRate: '/fx-rates',
    getSelfServicePricingSlabs: '/pricing-slabs',
    createSelfServicePricingSlab: '/pricing-slabs',
    updateSelfServicePricingSlab: '/pricing-slabs',
    getSelfServiceCatalog: '/services/catalog',
    createSelfServiceCatalog: '/services/catalog',
    getAllFxCurrencyCodes: '/fx-rates/all-currencies',
    getSelfServicePlan: '/plans',
    confirmBankTransferPayment: '/self_service/confirmBankTransferPayment',
    getOomeroBankDetails: '/self_service/oomeroBankDetails',
    // Offer codes for special company packages (Trello #270, 10 Oct 2026).
    offerCodeList: '/offer_code/list',
    offerCodeCreate: '/offer_code/create',
    offerCodeUpdate: '/offer_code/update',
    offerCodeRedemptions: '/offer_code/redemptions',
    offerCodeCheck: '/offer_code/check',
    offerCodeServices: '/offer_code/services',
    // SAR / STR reporting (Trello #271, 10 Oct 2026).
    strReportList: '/str_report/list',
    strReportGet: '/str_report/get',
    strReportCreate: '/str_report/create',
    strReportUpdate: '/str_report/update',
    strReportMove: '/str_report/move',
    strReportXml: '/str_report/xml',
    // CRM registers and the compliance dashboard (Trello #274, #272, 10 Oct 2026).
    crmRegisterPep: '/crm_register/pep',
    crmRegisterUbo: '/crm_register/ubo',
    crmRegisterAnnual: '/crm_register/annual',
    crmRegisterDashboard: '/crm_register/dashboard',
    crmRegisterRefreshScores: '/crm_register/refresh-scores',
    pendingBankTransfers: '/self_service/pendingBankTransfers',
    getSelfServicePlanPricingContext: '/plans',
    quotePreviewSelfServicePlan: '/plans/quote-preview',
    confirmSelfServicePlan: '/plans/confirm',
    updateSelfServicePlan: '/plans',
    getSelfServiceFormTemplates: '/form-templates',
    sdkPermissions: '/sdk/permissions',
    updateSelfServiceFormTemplate: '/form-templates',
    getOnboardingPlans: '/plans/onboarding',
    createOnboardingPlan: '/plans/onboarding',
    createPublicOnboardingPlan: '/plans/onboarding/public-builder',
    previewPublicOnboardingPlan: '/plans/onboarding/public-builder/preview',
    updateOnboardingPlan: '/plans/onboarding',
    deleteOnboardingPlan: '/plans/onboarding',
    verifyPayBalanceOtp: '/invoice/verifyPayBalanceOtp',
    fetchInvoiceDetail: '/invoice/fetchInvoiceDetail',
    entityPreviousInvoiceList: '/invoice/entityInvoiceList',
    getEntityDetails: '/entity/getEntityDetails',
    getPostpaidEntityDetails: '/user/getPostpaidEntityDetails',
    sendForgotPasswordCode: "user/sendForgotPasswordCode",
    resetPasswordOtpVerify: "/user/verifyForgotPasswordCode",
    changeForgetPassword: "user/setNewPassword",
    getAllPackage: "package/getAllPackage",
    deactivatePackage: "package/deactivatePackage",
    updatePackage: "package/update",
    createNewPackage: "package/create",
    getInvoiceData: "/invoice/getMyInvoices",
    saveIndividualPersonalDetails: "/individual_onboarding/saveIndividualPersonalDetails",
    saveIndividualAddress: "/individual_onboarding/saveIndividualAddress",
    uploadEntityClientDocument: "/individual_onboarding/uploadEntityClientDocument",
    saveEntityClientKycDetail: "/individual_onboarding/saveEntityClientKycDetail",
    getEntityClientCompany: "/individual_onboarding/getEntityClientCompany",
    getEntityClientBank: "/individual_onboarding/getEntityClientBank",
    postEntityClientCompany: "/individual_onboarding/createEntityClientCompany",
    generateFaceKycLink: "/individual_onboarding/generateFaceKycLink",
    processFaceKyc: "/individual_onboarding/processFaceKyc",
    getOnboardingApplications: "/individual_onboarding/getOnboardingApplications",
    resendOnboardingInviteLink: "/individual_onboarding/resendOnboardingInviteLink",
    postEntityClientBank: "/individual_onboarding/createEntityClientBanks",
    fetchEntityClientPersonalDetail: "individual_onboarding/fetchEntityClientPersonalDetail",
    fetchEntityClientAddress: "/individual_onboarding/fetchEntityClientAddress",
    updateIndividualPersonalDetails: "/individual_onboarding/updateIndividualPersonalDetails",
    generateOnboardingInviteLink: "/individual_onboarding/generateOnboardingInviteLink",
    fetchEntityData: '/individual_onboarding/fetchEntityData',
    deductKYCLivelynessCharge: '/individual_onboarding/chargeKYCLivelyness',
    getIndividualScreeninglist: '/individual_screening/getIndividualScreeninglist',
    listPendingKYCIndividualScreening: '/individual_screening/getInactiveOomeroClients',
    updateIndividualPersonalDetailsWithReason: '/individual_screening/updateIndividualPersonalDetailsWithReason',
    updateKycOcrMetadata: '/individual_screening/updateKycOcrMetadata',
    addScreeningComments: '/individual_screening/addScreeningComments',
    getEntityClientBankDetails: '/individual_onboarding/getEntityClientBankDetails',
    getEntityClientCompanyDetails: '/individual_onboarding/getEntityClientCompanyDetails',
    listKycDocuments: '/individual_screening/listKycDocuments',
    requestDocument: '/individual_screening/requestDocument',
    uploadDocument: '/individual_screening/uploadDocument',
    updateScreeningInfo: '/individual_screening/updateScreeningInfo',
    getScreeningComments: '/individual_screening/getScreeningComments',
    getFieldHistory: '/individual_screening/getFieldHistory',
    getCustomerInteractionLog: '/individual_screening/getCustomerInteractionLog',
    getGlobalSearchById: '/individual_screening/getGlobalSearchById',
    getAllGlobalSearchById: '/individual_screening/getAllGlobalSearchById',
    getIndividualScreeningClientHistory: "/individual_screening/getIndividualScreeningClientHistory",
    saveRelevantResult: "/individual_screening/saveRelevantResult",
    removeRelevantResult: "/individual_screening/removeRelevantResult",
    getSearchCertificate: "/individual_screening/getSearchCertificate",
    manageScreeningAction: "/individual_screening/manageScreeningAction",
    getInactiveOomeroApplications: "/individual_screening/getInactiveOomeroApplications",
    resendFaceKycLink: "/individual_onboarding/resendFaceKycLink",
    getAdverseMedia: "/individual_screening/getAdverseMedia",
    manageContinuousMonitoring: "/individual_screening/manageContinuousMonitoring",
    saveExcludedAdverseMedia: "/individual_screening/saveExcludedAdverseMedia",
    checkUKVatNo: "/individual_onboarding/checkUKVatNo",
    manageEntityClientStatus: "/individual_screening/manageEntityClientStatus",
    refreshToken: `/user/refreshToken`,
    saveAmlInfoComment: "/individual_screening/saveAmlInfoComment",
    saveAdverseMediaComment: "/individual_screening/saveAdverseMediaComment",
    downloadClientDocZipFiles: "/individual_screening/downloadClientDocZipFiles",
    resendToCheckerMaker: "/individual_screening/resendToCheckerMaker",
    packageUpdate: "/package/update",
    getPackageDetails: "/package/getPackageDetails",
    fetchAmlComments: "/individual_screening/fetchAmlComments",
    fetchUploadedDocuments: "/individual_screening/fetchUploadedDocuments",
    uploadMediaImage: "/individual_screening/uploadMediaImage",
    autoSearchAddress: "/individual_onboarding/autoSearchAddress",
    resendToScreening: "/individual_screening/resendToScreening",
    checkEUVatNo: "/individual_onboarding/checkEUVatNo",
    getIndividualScreeningPercentage: "/dashboard/getIndividualScreeningPercentage",
    getKeyStatsForGraph: "/dashboard/getKeyStatsForGraph",
    getStatsByGraph: "/dashboard/getStatsByGraph",
    sendToCheckerMlro: "/individual_screening/sendToCheckerMlro",
    checkPanUrl: "/individual_onboarding/checkPan",
    checkAadhaarUrl: "/individual_onboarding/checkAadhaar",
    getOnboardedClientReport: "/individual_onboarding/getOnboardedClientReportData",
    downloadOnboardedClientReport: "/individual_onboarding/downloadOnboardedClientReport",
    downloadOnboardedClientReportPackage: "/individual_onboarding/downloadOnboardedClientReportPackage",
    getEntityCertificate: "/individual_screening/getEntityCertificate",
    searchCorporateCompany: "/corporate_onboarding/searchCorporatePersonalDetails",
    getPreviousSearchRecords: "/aml_check/getPreviousSearchRecords",
    initialSearch: "/aml_check/initialSearch",
    startAmlFullOnboarding: "/aml_check/startFullOnboarding",
    saveCompanyAddress: "/corporate_onboarding/saveCompanyAddress",
    updateCompanyAddress: "/corporate_onboarding/updateCompanyAddress",
    saveCompanyDetailsAndAddress: "/corporate_onboarding/saveCompanyDetailsAndAddress",
    saveCorporateRegulatoryDocuments: "/corporate_onboarding/saveRegulatoryDocuments",
    getCorporateRegulatoryDocuments: "/corporate_onboarding/getRegulatoryDocuments",
    saveCorporateCompliance: "/corporate_onboarding/saveCompliance",
    getCorporateCompliance: "/corporate_onboarding/getCompliance",
    saveCorporateMlro: "/corporate_onboarding/saveMlroDetails",
    getCorporateMlro: "/corporate_onboarding/getMlroDetails",
    deleteCorporateMlro: "/corporate_onboarding/deleteMlroDetails",
    updateCompanyDetailsAndAddress: "/corporate_onboarding/updateCompanyDetailsAndAddress",
    getCompanyAddress: "/corporate_onboarding/getCompanyAddress",
    getCompanyDetails: "/corporate_onboarding/getCompanyDetailsForAll",
    saveCorporateDeatils: "/corporate_onboarding/saveCorporatePersonalDetails",
    getCompanyHouseCorporateDetails: "/corporate_onboarding/redFlagCompanyHouseCorporateDetails",
    createBankDetails: "corporate_onboarding/createBankDetails",
    updateBankDetails: "/corporate_onboarding/updateBankDetails",
    uploadDocuments: "corporate_onboarding/uploadDocuments",
    updateUploadDocuments: "/corporate_onboarding/updateUploadDocuments",
    fetchCorporateBankDetails: "/corporate_onboarding/fetchCorporateBankDetails",
    fetchCorporateUploadedDocument: '/corporate_onboarding/fetchCorporateUploadedDocument',
    fetchAmlCheckSearchDetails: "/aml_check/fetchAmlCheckSearchDetails",
    amlCheckManageContinuousMonitoring: "/aml_check/manageContinuousMonitoring",
    amlCheckContinuousMonitoringPrice: "/aml_check/continuousMonitoringPrice",
    getAmlCheckSearchCertificate: "/aml_check/getAmlCheckSearchCertificate",
    getAmlCheckEntityCertificate: "/aml_check/getAmlCheckEntityCertificate",
    getCompanyOfficers: "/corporate_onboarding/getCompanyOfficers",
    deleteCompanyOfficers: "/corporate_onboarding/deleteCompanyOfficers",
    getEntityClientDetailsByOomeroId: "/corporate_onboarding/getEntityClientDetailsByOomeroId",
    verifyEntityClientDetailsOtp: "/corporate_onboarding/verifyEntityClientDetailsOtp",
    saveCorporateClientOfficer: "/corporate_onboarding/saveCorporateClientOfficer",
    triggerKycOnboardEmail: "/corporate_onboarding/triggerKycOnboardEmail",
    saveAmlCheckComment: "/aml_check/saveAmlCheckComment",
    fetchAmlCheckComments: "/aml_check/fetchAmlCheckComments",
    getCorporateIndividualShareholder: "/corporate_onboarding/getCorporateIndividualShareholder",
    saveCorporateIndividualShareholder: "/corporate_onboarding/saveCorporateIndividualShareholder",
    fetchAllCorporateIndividualShareholders: "/corporate_onboarding/fetchAllCorporateIndividualShareholders",
    saveCompanyShareholderRepresentativeDetails: "/corporate_onboarding/saveCompanyShareholderRepresentativeDetails",
    getCompanyShareholderRepresentativeDetails: "/corporate_onboarding/getCompanyShareholderRepresentativeDetails",
    updateCompanyShareholderRepresentativeDetails: "/corporate_onboarding/updateCompanyShareholderRepresentativeDetails",
    getCorporateScreeninglist: "/corporate_screening/getCorporateScreeninglist",
    manageCorporateContinuousMonitoring: "/corporate_screening/manageContinuousMonitoring",
    getCorporateClientDetails: "/corporate_onboarding/getCorporateClientDetails",
    generateCorporateClientOomeroId: "/corporate_onboarding/generateCorporateClientOomeroId",
    fetchCorporateClientPersonalDetail: "/corporate_screening/fetchCorporateClientPersonalDetail",
    getCorporateLinkedIndividuals: "/corporate_screening/getCorporateLinkedIndividuals",
    manageCorporateClientStatus: "/corporate_screening/manageCorporateClientStatus",
    downloadCorporateClientDocZipFiles: "/corporate_screening/downloadCorporateClientDocZipFiles",
    downloadCorporateReportPackage: "/corporate_onboarding/downloadCorporateReportPackage",
    addCorporateScreeningComments: "/corporate_screening/addScreeningComments",
    updateCorporateDetailsWithReason: "/corporate_screening/updateCorporateDetailsWithReason",
    saveCorporateRelevantResult: "/corporate_screening/saveRelevantResult",
    removeCorporateRelevantResult: "/corporate_screening/removeCorporateRelevantResult",
    getCorporateGlobalSearchById: "/corporate_screening/getGlobalSearchById",
    fetchRequestedUploadedDocuments: "/corporate_screening/fetchRequestedUploadedDocuments",
    corporateRequestDocument: '/corporate_screening/requestDocument',
    corporateUploadDocument: '/corporate_screening/uploadDocument',
    corporateUpdateScreeningInfo: '/corporate_screening/updateScreeningInfo',
    corporateResendToCheckerMaker: "/corporate_screening/resendToCheckerMaker",
    corporateSendToCheckerMlro: "/corporate_screening/sendToCheckerMlro",
    corporateManageScreeningAction: "/corporate_screening/manageScreeningAction",
    fetchCorporateBankDetailsById: '/corporate_onboarding/fetchCorporateBankDetailsById',
    getCorporateFieldHistory: '/corporate_screening/getCorporateFieldHistory',
    getCorporateScreeningComments: '/corporate_screening/getCorporateScreeningComments',
    getCorporateScreeningClientHistory: "/corporate_screening/getCorporateScreeningClientHistory",
    fetchCorporateRequestedDocuments: '/corporate_screening/fetchCorporateRequestedDocuments',
    getCorporateTransactionsList: '/corporate_transaction/getTransactionsList',
    createCorporateTransaction: '/corporate_transaction/create',
    getCorporateTransactionDocuments: '/corporate_transaction/getDocuments',
    fetchPendingCorporateScreeningCount: '/corporate_screening/fetchPendingCorporateScreeningCount',
    triggerReKycEmail: '/corporate_screening/triggerReKycEmail',
    getClientIndividualScreeninglist: '/individual_screening/getClientIndividualScreeninglist',
    updateCorporateClientOfficer: '/corporate_onboarding/updateCorporateClientOfficer',
    updateCorporateIndividualShareholder: '/corporate_onboarding/updateCorporateIndividualShareholder',
    getIndividualProfileByOomeroId: '/individual_onboarding/getIndividualProfileByOomeroId',
    individualOnboardUsingOomeroId: '/individual_onboarding/individualOnboardUsingOomeroId',
    getCorporateProfileByOomeroId: '/corporate_onboarding/getCorporateProfileByOomeroId',
    corporateOnboardingUsingOomeroId: '/corporate_onboarding/corporateOnboardingUsingOomeroId',
    getPreviousSearches: '/company_search/getPreviousSearches',
    getCompanySearchDetails: '/company_search/getCompanySearchDetails',
    getCorporateAmlReportData: '/corporate_onboarding/getCorporateAmlReportData',
    getPaymentHistory: '/order/getPaymentHistory',
    corporateResendToScreening: '/corporate_screening/resendToScreening',
    getCompanyReportData: '/company_search/getCompanyReportData',
    getCorporateSearchCertificate: '/corporate_screening/getCorporateSearchCertificate',
    getOnboardingApplications: '/individual_onboarding/getOnboardingApplications',
    getIndividualScreeningPercentageOnboarded: "/dashboard/getIndividualScreeningPercentage?section=onboarded",
    getIndividualScreeningPercentageScreening: "/dashboard/getIndividualScreeningPercentage?section=screening",
    getCorporateBucketStatus: "/dashboard/getCorporateBucketStatus",
    sendPostPaidClientLink: "/user/sendPostPaidClientLink",
    onboardPostpaidEntity: "/user/onboardPostpaidEntity",
    setPostPaidClientPassword: "user/setPostPaidClientPassword",
    duplicateApproveReject: "individual_screening/duplicateApproveReject",
    fetchPostpaidBillingList: "/invoice/fetchPostpaidBillingList",
    fetchPostpaidClientBillingDetails: "/invoice/fetchPostpaidClientBillingDetails",
    getWalletTransactionTable: "/wallet/transactions",
    walletBalance: '/wallet/getWalletBalance',
    walletTransactions: '/wallet/getWalletTransactions',
    walletTopup: '/wallet/prepaidTopUpWallet',
    walletPaymentResponse: '/wallet/paymentResponse',
    walletPaymentFinalize: '/wallet/paymentFinalize',
    walletDebit: '/wallet/debit',
    getAllEmailTemplates: '/email_template/all',
    createCustomEmailTemplate: '/email_template/custom',
    getEntityLogo: '/email_template/entity-logo',
    uploadEntityLogo: '/email_template/entity-logo/upload',
    getGeographicRiskList: '/geographic_risk/list',
    updateGeographicRisk: '/geographic_risk/update',
    createGeographicRisk: '/geographic_risk/create',
    deleteGeographicRisk: '/geographic_risk/delete',
    getFatfSyncStatus: '/geographic_risk/fatf-sync/status',
    syncFatfCountries: '/geographic_risk/fatf-sync',
    getFatfMap: '/geographic_risk/fatf-map',
    getCountriesList: '/geographic_risk/countries',
    generatePostpaidInvoice: '/invoice/generatePostpaidInvoice',
    submitCustomPackageInquiry: '/package/submitCustomPackageInquiry',
    getInquiriesCount: '/package/getInquiriesCount',
    getAllInquiries: '/package/getAllInquiries',
    updateInquiryStatus: '/package/updateInquiryStatus',
    getRiskScoringQuestions: '/riskScoring/questions',
    submitRiskScoringResponse: '/riskScoring/response',
    getTotalRisk: '/riskScoring/total-risk',
    uploadRiskEvidence: '/riskScoring/upload-evidence',
    getUserAnswers: '/riskScoring/user-answers',
    createFullTransaction: '/individual_transaction/createFullTransaction',
    getTransactionsList: '/individual_transaction/getTransactionsList',
    transactionUploadDocument: '/individual_transaction/uploadDocument',
    getTransactionDocuments: '/individual_transaction/getTransactionDocuments',
    getIndividualDocuments: '/individual_transaction/getIndividualDocuments',
    getTaxesByCountry: '/tax/getTaxesByCountry',
    getUserLogs: '/v1/user-logs',
    getAllEntityWalletBalances: '/wallet/getAllEntityWalletBalances',
    downloadWalletInvoice: '/invoice/downloadWalletInvoice',
    sendWalletInvoiceEmail: '/invoice/sendWalletInvoiceEmail',
    createApiKey: '/user/api-keys',
    listApiKeys: '/user/api-keys',
    revokeApiKey: '/user/api-keys',
    apiKeyUsageDashboard: '/user/api-keys/usage-dashboard',
    requestApiAccess: '/user/api-key-requests',
    listApiAccessRequests: '/user/api-key-requests',
    approveApiAccessRequest: '/user/api-key-requests',
    rejectApiAccessRequest: '/user/api-key-requests',
    createCrmRegistration: '/v1/crm/registrations',
    getCrmRegistration: '/v1/crm/registrations',
    crmWebhooks: '/v1/crm/webhooks',
    crmWebhookDeliveries: '/v1/crm/webhook-deliveries',

    // Third-party onboarding (Requirements 9.1–9.5)
    thirdPartySaveOnboarding: '/third_party_onboarding/saveOnboarding',
    thirdPartyTriggerAmlCheck: '/third_party_onboarding/triggerAmlCheck',
    thirdPartyTriggerFullOnboarding: '/third_party_onboarding/triggerFullOnboarding',
    thirdPartyGetOnboarding: '/third_party_onboarding/getOnboarding',

    // Company payer (Requirements 2.1–5.5)
    companyPayerSave: '/company_payer/save',
    companyPayerValidate: '/company_payer/validate',

    // Document service (Requirements 5.4–5.5)
    generateAuthorisationForm: '/document/generateAuthorisationForm',
    emailDocument: '/document/emailDocument',

    // Entity — client code preference (Requirement 6.1)
    updateEntityClientCodePreference: '/entity/updateClientCodePreference',
    clientRekycSettings: '/entity/client-rekyc-settings',

    // Transaction — inline client code update (Requirements 6.2–6.3)
    updateTransactionClientCode: '/individual_transaction/updateClientCode',

    // Mortgage & Loan details
    getEntityClientMortgages: '/individual_onboarding/getEntityClientMortgages',
    addEntityClientMortgage: '/individual_onboarding/addEntityClientMortgage',
    updateEntityClientMortgage: '/individual_onboarding/updateEntityClientMortgage',
    uploadMortgageDocument: '/individual_onboarding/uploadMortgageDocument',

    // Governance V1.1
    governanceBootstrap: '/governance/bootstrap',
    governanceOverview: '/governance/overview',
    governanceFieldPolicy: '/governance/field-policy',
    governanceRetention: '/governance/retention',
    governanceAccessGrants: '/governance/access-grants',
    governancePurgeRequests: '/governance/purge-requests',
    governanceAuditLog: '/governance/audit-log',
    governanceRetentionStatus: '/governance/retention-status',
    governanceCompanies: '/governance/companies',
    governanceCompanyFields: '/governance/company-fields',
    governanceIndustries: '/governance/industries',
    governanceIndustriesRemoved: '/governance/industries/removed',
    governanceCategories: '/governance/categories',
    industryCatalog: '/industry/catalog',
    partnerContractPropspace: '/partner_contract/propspace',
    adverseMediaArticle: '/adverse_media_evidence/articles',
    adverseMediaCardCaptures: '/adverse_media_evidence/cards',
    // A Google News story from a Media Cross-check, opened and kept like an article.
    adverseMediaStory: '/adverse_media_evidence/stories',
    // Comments on a Media Cross-check story (7 Oct 2026).
    adverseMediaStoryComments: '/adverse_media_compare/comments',
    partnerContractPropspaceCheck: '/partner_contract/propspace/check',
    partnerContractPropspaceTestWebhook: '/partner_contract/propspace/test-webhook',
    industryCategories: '/industry/categories',
    workflowCatalog: '/workflow/catalog',
    workflowDefinitions: '/workflow/definitions',
    workflowJourney: '/workflow/journey',
    enhancedDueDiligence: '/individual_screening/enhancedDueDiligence',
    // Client book (client list report + Key Details relationship card)
    clientBookList: '/client_book/list',
    clientBookSummary: '/client_book/summary',
    // KYP checklist (per-company template, per-customer checklist, customer link)
    kypTemplate: '/kyp/template',
    kypChecklist: '/kyp/checklist',
    kypPublicInspect: '/kyp/public/inspect',
    kypPublicUpdate: '/kyp/public/update',
    // Periodic client review (directors confirm changes every N months)
    clientReviewSettings: '/client_review/settings',
    clientReviewCompany: '/client_review/company',
    clientReviewPublicInspect: '/client_review/public/inspect',
    clientReviewPublicSubmit: '/client_review/public/submit',
    // Documents checklist (company documentary checklist, customer upload link)
    documentChecklist: '/document_checklist',
    documentChecklistTemplate: '/document_checklist/template',
    documentChecklistUpload: '/document_checklist/upload',
    documentChecklistArchive: '/document_checklist/archive',
    documentChecklistRequest: '/document_checklist/request',
    documentChecklistPublicInspect: '/document_checklist/public/inspect',
    documentChecklistPublicUpload: '/document_checklist/public/upload',
    // Supply chain and compliance declaration
    supplyChainSettings: '/supply_chain/settings',
    supplyChainDeclaration: '/supply_chain/declaration',
    supplyChainPublicInspect: '/supply_chain/public/inspect',
    supplyChainPublicSubmit: '/supply_chain/public/submit',
    // Shipments (refinery transactions with their documents and suppliers)
    shipments: '/shipment',
    shipmentTemplate: '/shipment/template',
    shipmentSuppliers: '/shipment/suppliers',
    shipmentPublicInspect: '/shipment/public/inspect',
    shipmentPublicDetails: '/shipment/public/details',
    shipmentPublicDocuments: '/shipment/public/documents',
    shipmentPublicSuppliers: '/shipment/public/suppliers',
    shipmentPublicSubmit: '/shipment/public/submit',
    // Refinery workspace (its own section: overview, clients, shipments across companies)
    refineryOverview: '/refinery/overview',
    refineryClients: '/refinery/clients',
    refineryShipments: '/refinery/shipments',
    refineryOnboardings: '/refinery/onboardings',
    // Refinery onboarding (Company Overview style form per customer company, customer link)
    refineryOnboardingForm: '/refinery_onboarding/form',
    refineryOnboardingStart: '/refinery_onboarding/start',
    refineryOnboardingCompany: '/refinery_onboarding/company',
    refineryOnboardingPublicInspect: '/refinery_onboarding/public/inspect',
    refineryOnboardingPublicSave: '/refinery_onboarding/public/save',
    helpArticles: '/help/articles',
    helpUpload: '/help/upload',
    publicProfileSearch: '/public_profile_finder/search',
    publicProfilePlatforms: '/public_profile_finder/platforms',
    profileSourcesLookup: '/profile_sources/lookup',
    profileSourcesLatest: '/profile_sources/lookup/latest',
    profileSourcesLinks: '/profile_sources/links',
    profileSourcesSearch: '/profile_sources/search',
    profileSourcesSearches: '/profile_sources/searches',
}
